module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "transition": "scale-transition",
      "offset-y": "",
      "disabled": _vm.disabled,
      "full-width": "",
      "max-width": "290px",
      "min-width": "290px",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "slot": "activator",
            "label": _vm.label,
            "readonly": "",
            "disabled": _vm.disabled,
            "hide-details": ""
          },
          slot: "activator",
          model: {
            value: (_vm.date),
            callback: function($$v) {
              _vm.date = $$v
            },
            expression: "date"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "allowedDates": _vm.allowedDates
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cab4c01a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@sdgsystems/vue-common/components/DateView.vue
// module id = 455
// module chunks = 1